type Tab = "controls" | "notes";

type RemoteTabsProps = {
  value: Tab;
  onChange: (tab: Tab) => void;
  controlsLabel: string;
  notesLabel: string;
};

export default function RemoteTabs({
  value,
  onChange,
  controlsLabel,
  notesLabel,
}: RemoteTabsProps) {
  const tabClass = (active: boolean) =>
    `flex-1 py-1.5 text-xs font-medium rounded-md transition-all cursor-pointer ${
      active ? "bg-white text-gray-800 shadow-sm" : "text-gray-500"
    }`;
  return (
    <div className="flex gap-1 bg-gray-100 rounded-lg p-1 mb-2 flex-shrink-0">
      <button
        onClick={() => onChange("controls")}
        className={tabClass(value === "controls")}
      >
        <i className="ri-remote-control-line mr-1" />
        {controlsLabel}
      </button>
      <button
        onClick={() => onChange("notes")}
        className={tabClass(value === "notes")}
      >
        <i className="ri-sticky-note-line mr-1" />
        {notesLabel}
      </button>
    </div>
  );
}
